import { createContext, useContext } from 'react';
import { FormFieldsData } from 'framework/form';
import { ListResponse, LoadingParams } from 'framework/list';
import {
  DocumentStorageConfig,
  DocumentStorageItemType,
  RenderDocumentDataTypes,
  RenderPreviewDocumentDataTypes,
} from './types';

// Do not change the required fields
// These functions are necessary for minimal functionality with document storage
export interface DocumentStorageContextData {
  searchDocuments(params: LoadingParams): Promise<ListResponse<DocumentStorageItemType>>;
  getDocumentByPaths(paths: string[]): Promise<DocumentStorageItemType[]>;
  uploadDocument(data: FormFieldsData): Promise<{
    paths: string[];
    id: string[];
  }>;
  editDocument(data: FormFieldsData): Promise<FormFieldsData>;
  deleteDocument?(path: string): Promise<void>;
  getDocumentTemplateConfig?: (templatePath: string, additionalData?: any) => Promise<DocumentStorageConfig>;
  getDocumentToken(path: string): Promise<string>;
  renderDocumentTemplate?: (data: RenderDocumentDataTypes) => Promise<any>;
  renderPreviewDocumentTemplate?: (data: RenderPreviewDocumentDataTypes) => Promise<{ id: string; path: string }>;
  getValidationSchema(): Promise<any>;
}

const DocumentStorageContext = createContext<Nullable<DocumentStorageContextData>>(null);
const DocumentStorageContextProvider = DocumentStorageContext.Provider;

const useDocumentStorageContext = ({ ignoreContext = false }: { ignoreContext?: boolean } = {}) => {
  const context = useContext(DocumentStorageContext);
  if (!context && !ignoreContext) {
    throw new Error('useDocumentStorageContext must be used within DocumentStorageProvider');
  }
  return context || ({} as DocumentStorageContextData);
};
export { useDocumentStorageContext, DocumentStorageContextProvider };
